import React, { useState, useEffect } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { useTranslation } from 'react-i18next'

import CustomButton from '../../component/CustomButton'
import { tableNoPaginationOptions } from '../../component/helpers/table'

const CustomAPN = (props) => {
    const { t } = useTranslation('translation', { keyPrefix: 'companiesPage.customAPN' });
    const { custom_apn, onUpdateApn } = props
    const apns = [{ id: 'Default', flag: 0 }]
    if (custom_apn.length) {
        custom_apn.split(',').forEach(item => {
            apns.push({ id: item, flag: 1 })
        })
    }

    // const [apns, setApns] = [{id: 'Default', flag: 0}]
    const [apn_name, setApn_name] = useState('')
    const [errapn_name, setErrapn_name] = useState('')

    // useEffect(() => {

    // }, [custom_apn])

    const checkApn = () => {
        let error = false
        let errapn = ''

        if (apn_name === '') {
            error = true
            errapn = t('errValue')
        }
        else if (custom_apn.split(',').includes(apn_name)) {
            error = true
            errapn = t('errAPNexists')
        }
        else if (custom_apn.split(',').length >= 5) {
            error = true
            errapn = t('errRemoveAPN')
        }
        else if ((custom_apn + apn_name).length > 256) {
            error = true
            errapn = t('errAPNValuesTooLong')
        }

        // if (!updatedErrMessage['email']) {
        // 	let re = /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // 	if (!re.test(data['email'])) {
        // 		error = true;
        // 		updatedErrMessage['email'] = t('errEmailNotValid');
        // 	}
        // }

        setErrapn_name(errapn)
        return error
    }

    const onAddClick = (e) => {
        e.preventDefault()

        const error = checkApn()
        if (!error) {
            const newApns = [...apns, { id: apn_name, flag: 1 }].filter(({ flag }) => flag === 1).map(({ id }) => id).join(',')
            onUpdateApn(e, newApns)
        }
    }

    const onRemoveClick = (e, apnArg) => {
        e.preventDefault()
        const newApns = apns.filter(({ id, flag }) => id !== apnArg.id && flag === 1).map(({ id }) => id).join(',')
        onUpdateApn(e, newApns)
    }


    const formatActions = (cell, row) => {
        if (row.flag) {
            return (
                <CustomButton
                    variant="link"
                    prefix="error-label"
                    onClick={(e) => onRemoveClick(e, row)}
                >
                    {t('btnRemove')}
                </CustomButton>
            )
        }
    }

    return (
        <div className="company-custom-apn">
            <div className={`subheader-section search-flex mb-10 ${errapn_name && 'has-error'}`}>
                <label className="search-label">{t('labelCustomAPN')}</label>
                <div>
                    <input
                        type="text"
                        name="apn_name"
                        className="vehicle-search apn-name"
                        placeholder={t('placeholder')}
                        onChange={(e) => setApn_name(e.target.value)}
                        value={apn_name}
                    />
                    <CustomButton
                        variant="link"
                        onClick={onAddClick}
                    >
                        {t('btnAdd')}
                    </CustomButton>
                </div>
                {errapn_name && <span className="help-block">{errapn_name}</span>}
            </div>

            <BootstrapTable
                data={apns}
                {...tableNoPaginationOptions}
            // tableContainerClass="rosco-table manage-vehicles-table"
            // headerContainerClass="rosco-table-header custom-table-header-container manage-vehicles-table-header"
            // bodyContainerClass="rosco-table-body manage-vehicles-table-body"
            // csvFileName="companies_report.csv"
            >
                <TableHeaderColumn dataField="id" dataSort isKey>
                    {t('headerAPN')}
                </TableHeaderColumn>
                <TableHeaderColumn width="30%" dataFormat={formatActions}>
                    {t('headerActions')}
                </TableHeaderColumn>


            </BootstrapTable>
        </div>
    )
}

export default CustomAPN;
